.bq{position:absolute;}